import { TrackingEventUrls } from './const.js';

const ENV = window.runtime_configs.REACT_APP_ETRACKING_ENV;
const ETRACKING_ENV = window.runtime_configs.REACT_APP_ETRACKING_ENV;
const VERSION = window.runtime_configs.REACT_APP_ETRACKING_VERSION;
const arrPreviousEvent = [];

const createSession = (callback) => {
    window.ZPI_TRACKING_SDK.createSession(ETRACKING_ENV, VERSION, rs => {
        if (rs.code === 0) {
            const sid = rs.data.trackingSession;
            window.sessionId = sid;
            callback(sid);
        } else {
            /**
             * @return callback error as string
             */
            callback(JSON.stringify(rs));
        }
    });
}

const trackingEventCallAPI = (eventId, session, metadata) => {
    let elmPreviousEvent = '';

    if (eventId) {
        arrPreviousEvent.push(eventId);
    }

    if (arrPreviousEvent.length > 1) {
        elmPreviousEvent = `03.${arrPreviousEvent.slice(-2)[0]}`;
    }

    const apiPath = TrackingEventUrls[ENV] || '';
    console.log({apiPath});
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    const params = {
        timestamp: new Date().toISOString(),
        event_id: `03.${eventId}`,
        metadata: JSON.stringify(metadata),
        previous_event_id: elmPreviousEvent,
        tracking_session_id: session,
    };
    const method = 'POST';
    // eslint-disable-next-line consistent-return
    return fetch(apiPath, {
        method,
        headers,
        body: JSON.stringify({ ...params }),
    })
        .then(resp => resp)
        // eslint-disable-next-line prefer-promise-reject-errors
        .catch(error => console.log('trackingEventCallAPI error',error));
}

export { trackingEventCallAPI, createSession }
